import { QueryClient } from '@tanstack/react-query';
import { type ReactElement } from 'react';

import { prepopulateCache } from '$shared/utils/react-query.utils';

import { createGetStabilityReportQuery } from '$features/report-hub/report-hub.api';
import { StabilityReportSidecar } from '$features/report-hub/stability-report/stability-report-sidecar';
import { StabilityReportDetailModel } from '$features/report-hub/stability-report/stability-report.types';

export async function stabilityReportDetailLoader(
  queryClient: QueryClient,
  reportId: string,
): Promise<null> {
  return prepopulateCache<StabilityReportDetailModel>(
    queryClient,
    createGetStabilityReportQuery(reportId),
  );
}

export function StabilityReportDetailPage(): ReactElement {
  return <StabilityReportSidecar />;
}
